<template>
  <div class="wrap_address">
    <div>
      <h4 class="title-color">Manage Pages of Roles</h4>
    </div>
    <div>
      <div v-for="(applicationPage, index) in applicationPages" :key="index">
        <div style="width: 80%">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Page Group"
            readonly="true"
            v-model="applicationPage.pageGroup"
          />
        </div>
        <div style="padding: 5px 1% 5px 5%; width: 60%" class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Page Name"
            readonly="true"
            v-model="applicationPage.pageName"
          />
        </div>
        <div style="padding: 5px 1% 5px 10%; width: 80%" class="form-row">
          <ul style="list-style-type: none; padding-inline-start: 0px">
            <li
              v-for="pagesInRole in applicationPage.pagesInRoles"
              :key="pagesInRole.id"
            >
              <div class="form-row" v-show="pagesInRole.roleId">
                <div style="text-align: right; width: 30%; font-size: 12px">
                  <label>{{ getRoleName(pagesInRole.roleId) }}:</label>
                </div>
                <div
                  style="
                    font-size: 9px;
                    font-style: italic;
                    width: 50px;
                    margin: 5px;
                  "
                  >
                  Denied
                </div>
                <div style="width: 50px">
                  <ejs-switch
                    :id="pagesInRole.id"
                    :checked="pagesInRole.contribute"
                    v-model="pagesInRole.contribute"
                  ></ejs-switch>
                </div>
                <span style="font-size: 9px; font-style: italic; width: 50px"
                  >Allowed</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="align-center-bottom">
      <ejs-button
        type="button"
        cssClass="e-info margin-button"
        v-on:click.native="btnSaveSettings"
        >Save Settings
      </ejs-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { SwitchPlugin } from '@syncfusion/ej2-vue-buttons';
import { mapGetters } from 'vuex';
import {
  FETCH_APPLICATIONS_PAGES,
  GET_ALL_ROLES,
  PATCH_PAGES_IN_ROLES,
} from '../store';

Vue.use(SwitchPlugin);

export default {
  name: 'ManagePagesRoles',
  async created() {
    await this.$store.dispatch(GET_ALL_ROLES).then((res) => {
      this.roles = res.data;
    });
    await this.$store.dispatch(FETCH_APPLICATIONS_PAGES);
  },
  data() {
    return {
      roles: [],
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
      applicationPages: 'applicationPages',
    }),
  },
  methods: {
    getPageRolePermission(objPagesInRole, roleId) {
      const permission = objPagesInRole.find((x) => x.roleId === roleId);
      return permission.contribute;
    },
    getRoleName(roleId) {
      const objRole = this.roles.find((x) => x.roleId === roleId);
      return objRole.roleName;
    },
    async btnSaveSettings() {
      try {
        const data = this.applicationPages;
        await this.$store.dispatch(PATCH_PAGES_IN_ROLES, data).then(() => {
          this.$parent.notificationToasts.push({
            title: 'Success!',
            content: 'User profile updated successfully.',
            cssClass: 'e-toast-success',
            timeOut: 5000,
          });
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please enter value in required fields.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>

<style>
@import "../../../assets/styles/eservices-base.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.e-open-link:before {
  content: "\e34a";
}
.e-dialog .e-dlg-header-content {
  background: #0f4b90;
  padding: 12px;
  margin-bottom: 20px;
}
.e-dlg-header,
.e-dlg-header * {
  color: white;
  width: auto !important;
}
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px 10px;
  width: 340px;
}

#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}

.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
